<template>
  <section class="home-features g-section">
    <div class="g-container">
      <div class="section-head">
        <h2>为什么选择我们</h2>
        <p>5 大核心优势，让保函办理更高效、更安心</p>
      </div>

      <div class="feature-grid">
        <div class="feature-card">
          <div class="ico ico-speed"></div>
          <h4>最快 3min出函</h4>
          <p>自动化审核流程，告别线下漫长的等待</p>
        </div>
        <div class="feature-card">
          <div class="ico ico-safe"></div>
          <h4>资金全程安全</h4>
          <p>合作机构覆盖多家银行及担保公司，资金全程监管</p>
        </div>
        <div class="feature-card">
          <div class="ico ico-mock"></div>
          <h4>费率低至 0.3%</h4>
          <p>批量议价能力，为企业节省大笔保费支出</p>
        </div>
        <div class="feature-card">
          <div class="ico ico-online"></div>
          <h4>100% 在线办理</h4>
          <p>申请、审核、出函、下载全流程线上化</p>
        </div>
        <div class="feature-card">
          <div class="ico ico-verify"></div>
          <h4>真伪公开查验</h4>
          <p>第三方平台公开验证，杜绝假保函风险</p>
        </div>
        <div class="feature-card">
          <div class="ico ico-service"></div>
          <h4>一对一客户经理</h4>
          <p>专属顾问全程跟进，问题第一时间响应</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default { name: 'HomeFeatures' }
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.section-head {
  text-align: center;
  margin-bottom: 40px;

  h2 {
    margin: 0 0 8px;
    font-size: 32px;
    font-weight: 700;
    color: @text-strong;
  }
  p {
    margin: 0;
    color: @text-muted;
    font-size: 14px;
  }
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.feature-card {
  padding: 32px 28px;
  background: #fff;
  border-radius: @radius-lg;
  border: 1px solid @border-light;
  transition: all @duration-base @ease-out;

  &:hover {
    transform: translateY(-4px);
    box-shadow: @shadow-lg;
    border-color: transparent;
  }

  .ico {
    width: 56px;
    height: 56px;
    border-radius: @radius-md;
    background: @primary-soft;
    margin-bottom: 20px;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      inset: 14px;
      background: @primary;
      border-radius: 6px;
    }

    &.ico-speed::before {
      mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path fill='%23000' d='M13 2L4 14h7l-1 8 9-12h-7z'/></svg>") center / contain no-repeat;
    }
    &.ico-safe::before {
      mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path fill='%23000' d='M12 2l9 4v6c0 5-3.5 9-9 10-5.5-1-9-5-9-10V6z'/></svg>") center / contain no-repeat;
    }
    &.ico-mock::before {
      mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path fill='%23000' d='M3 12l4-7h10l4 7-4 7H7z'/></svg>") center / contain no-repeat;
    }
    &.ico-online::before {
      mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path fill='%23000' d='M3 5h18v14H3z'/><path fill='%23fff' d='M3 9h18'/></svg>") center / contain no-repeat;
    }
    &.ico-verify::before {
      mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path fill='%23000' d='M9 16l-4-4 1.4-1.4L9 13.2l8.6-8.6L19 6z'/></svg>") center / contain no-repeat;
    }
    &.ico-service::before {
      mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path fill='%23000' d='M12 2a10 10 0 100 20 10 10 0 000-20z'/></svg>") center / contain no-repeat;
    }
  }

  h4 {
    margin: 0 0 8px;
    font-size: 17px;
    font-weight: 700;
    color: @text-strong;
  }

  p {
    margin: 0;
    color: @text-secondary;
    font-size: 13px;
    line-height: 1.7;
  }
}
</style>
